<template>
  <div class="bofang_body">
    <div class="tupian">
      <!--      <video id="media" style="width: 100%;" :src="urls" controls="controls" :poster="tupian">-->
      <!--        您的浏览器不支持 video 标签。-->
      <!--      </video>-->

      <video-player class="video-player vjs-custom-skin"
                    ref="videoPlayer"
                    :playsinline="true"
                    @play="play($event)"
                    @pause="pause($event)"
                    @ended="ended($event)"
                    @ready="playerReadied($event)"
                    :options="playerOptions"
      ></video-player>

    </div>


    <van-collapse v-model="value">
      <van-collapse-item  name="1">
        <template #title>
          <div style="font-size: 15px">
            视频目录
            <span style="margin-left: 20px;font-size: 12px;white-space:nowrap; overflow:hidden; text-overflow:ellipsis;color: #a8a8a8">
            正在播放 : {{titles}}</span></div>
        </template>
        <van-empty description="暂无视频，敬请期待！"  v-if="this.listsp==null || this.listsp.length==0"/>

        <div class="shiping" style="border-bottom: #f5f2f2 1px solid;padding-bottom: 6px" v-for="(item,index) in listsp">
          <div class="xiabiao" style="width: 15px">{{index+1}}</div>
          <div class="kecheng" style=";overflow: hidden;text-overflow:ellipsis;white-space: nowrap;width: 50%">{{item.titles}}</div>
          <div v-if="item.types==0" style="color: #FF00FF;position: absolute;right: 20%">正在学习</div>
          <div v-if="item.types==1" style="color:  #D9D9F3;position: absolute;right: 20%">已学习</div>
          <div class="bofang" @click="shiping(item)">
            <img v-if="item.ivs==1 " src="/bofang.png">
            <img v-if="item.ivs==0 " src="/suo.png">
          </div>
        </div>
      </van-collapse-item>
<!--      <van-collapse-item title="音频文件" name="2">-->
<!--        <div class="shiping" v-for="(item,index) in 5">-->
<!--          <div class="xiabiao">{{index+1}}</div>-->
<!--          <div class="kecheng">黄梅戏第一节</div>-->
<!--          <div class="bofang"><img src="/bofang.png"></div>-->
<!--        </div>-->
<!--      </van-collapse-item>-->
    </van-collapse>


  </div>
</template>

<script>
    import {Toast} from 'vant';
    import {videoPlayer} from 'vue-video-player'
    import 'video.js/dist/video-js.css'
    import { Notify } from 'vant';

    export default {
        name: "bank",
        data() {
            return {
                activeName: 'a',
                value: ['1'],
                inputt: '',
                tupian: '',
                biaoti: '',
                id:"",
                laoshi: '',
                youxiaoqi: '',
                zhuangtai: '',
                jine: '',
                renshu: '',
                jieshao: '',
                neirong: '',
                listsp: [],
                urls: '',
                statuse: '',
                jieshu: '',
                playerOptions: {},
                times:'',
                titles:"",
            }
        },
        components: {
            videoPlayer
        },
        computed: {
            player() {
                return this.$refs.videoPlayer.player
            }
        },
        created() {
            this.getcity()
        },
        mounted() {
            // var myVideo=document.getElementById("media");
            // myVideo.addEventListener('play',function(){
            //     console.log(document.getElementById("media").paused)
            // });
            // myVideo.addEventListener('pause',function(){
            //     console.log(document.getElementById("media").paused)
            // })
            // var myVid=document.getElementById("media");
            // console.log(myVid.ended,21321)

        },
        methods: {
            //播放
            play(e) {
                console.log("play")
            },
            //暂停
            pause(e) {
                if(e.currentTime()!=e.duration()){
                this.myrequest({
                    url: '/client/lookcurricumlums.action',
                    types: 'post',
                    data: {
                        id: this.$route.query.id,
                        time:e.currentTime()
                    },
                    succ: (res) => {

                    },
                    errs: (msg) => {

                    }
                })
                }
                // console.log("pause",e.currentTime())
                // console.log("pause",e.duration())
            },
            //看完
            ended(e) {
              Notify('自动播放下一节课');

                this.myrequest({
                    url: '/client/lookcurricumlums.action',
                    types: 'post',
                    data: {
                        id: this.id
                    },
                    succ: (res) => {
                      if (res.ivs==1) {
                        this.getcitys(res.id)
                      }else{
                        Notify('全部课程已经播放完毕');
                      }
                      // this.getcity()

                    },
                    errs: (msg) => {

                    }
                })
                // console.log("ended")
            },
            playerReadied(e){
              e.currentTime(this.times)
                console.log(this.times,213)
            },
            shiping(item) {
              console.log(item)
                if (item.ivs == 1) {
                  this.getcitys(item.id)
                }
                // } else if (this.statuse == 1) {
                //     this.$router.push({path: '/bofang', query: {id: item.id}})
                //     this.getcity()
                // }
            },
            getcity() {
                this.myrequest({
                    url: '/client/getcurriculumdata.action',
                    types: 'get',
                    data: {
                        // token:this.$store.state.token
                        id: this.$route.query.id,
                        types:1
                    },
                    succ: (res) => {

                      Notify('正在播放：'+res.titles);
                        this.titles=res.titles
                        this.listsp = res.data
                        this.urls = res.url
                        this.statuse = res.orderstatus
                        this.times=res.time
                        this.id=res.id

                        this.playerOptions = {
                            playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                            autoplay: false, //如果true,浏览器准备好时开始回放。
                            muted: false, // 默认情况下将会消除任何音频。
                            loop: false, // 导致视频一结束就重新开始。
                            preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                            language: 'zh-CN',
                            aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                            fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                            sources: [{
                                src: res.url,  // 路径
                                type: 'video/mp4'  // 类型
                            }],
                            poster: res.covermap, //你的封面地址
                            // width: document.documentElement.clientWidth,
                            notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                            controlBar: {
                                timeDivider: true,
                                durationDisplay: true,
                                remainingTimeDisplay: false,
                                fullscreenToggle: true  //全屏按钮
                            }
                        }

                    },
                    errs: (msg) => {

                    }
                })
            },
          getcitys(id) {
            this.myrequest({
              url: '/client/getcurriculumdata.action',
              types: 'get',
              data: {
                // token:this.$store.state.token
                id:id,
                types:1
              },
              succ: (res) => {
                Notify('正在播放：'+res.titles);
                this.titles=res.titles

                this.listsp = res.data
                this.urls = res.url
                this.statuse = res.orderstatus
                this.times=res.time
                this.id=res.id

                this.playerOptions = {
                  playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                  autoplay: false, //如果true,浏览器准备好时开始回放。
                  muted: false, // 默认情况下将会消除任何音频。
                  loop: false, // 导致视频一结束就重新开始。
                  preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                  language: 'zh-CN',
                  aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                  fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                  sources: [{
                    src: res.url,  // 路径
                    type: 'video/mp4'  // 类型
                  }],
                  poster: res.covermap, //你的封面地址
                  // width: document.documentElement.clientWidth,
                  notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                  controlBar: {
                    timeDivider: true,
                    durationDisplay: true,
                    remainingTimeDisplay: false,
                    fullscreenToggle: true  //全屏按钮
                  }
                }

              },
              errs: (msg) => {

              }
            })
          },
        }
    }
</script>

<style scoped lang="stylus">
  .bofang_body {
    width 100%;
    position relative;

    .video-js .vjs-big-play-button {
      margin-left 50%
    }

    .kechengxiangqing {
      width 95%;
      margin 10px auto;

      dl {
        width 100%

        dt {
          font-size 12pt
          font-weight 500
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }

        dd {
          margin-left 0
        }

        dd:nth-of-type(1) {
          font-size 9pt
          color #666
          line-height 200%
        }

        dd:nth-of-type(2) {
          font-size 13pt
          color #e9353e

          span {
            font-size 9pt
          }
        }

        dd:nth-of-type(3) {
          margin-top 5px
          color #888
          font-size 10pt
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
        }
      }

      .biaoti {
        font-weight 500;
        font-size 16px;
        color #333333;
        margin-left 10px;
      }

      .laoshi {
        font-weight 500;
        font-size 14px;
        color #ccc;
        margin-left 5px;
        margin-top 10px;
      }

      .cputong {
        font-weight 500;
        font-size 14px;
        color #ccc;
        margin-left 5px;
        margin-top 5px;
      }

      .xianshi {
        /*margin-left 5px;*/

        .xianshiname {
          font-weight 500;
          font-size 14px;
          color #ccc;
          margin-left 5px;
          margin-top 5px;
        }

        .youxiao {
          font-weight 500;
          font-size 14px;
          color #ccc;
          margin-left 5px;
          margin-top 5px;
        }

        .xianjia {
          font-weight 500;
          font-size 14px;
          color #ccc;
          margin-left 5px;
          margin-top 5px;
        }

        .suzhi {
          font-weight 500;
          font-size 14px;
          color #ccc;
          margin-left 5px;
          margin-top 5px;
        }

        .jieshi {
          font-weight 500;
          font-size 14px;
          color #ccc;
          margin-left 5px;
          margin-top 5px;
        }
      }
    }

    .foot {
      width 95%;
      margin auto;
      display flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      position fixed;
      bottom 0px;

      .shuru {
        width 85%;
      }

      .anniu {
        width 10%;
      }
    }

    .tupian {
      width 100%;
      max-height 100vw
      overflow hidden

      .video-player {
        width 100%

        >>> .video-js .vjs-big-play-button {
          width 20%
          margin-left 40%
          margin-top 15%
        }
      }

      img {
        width 100%;
        /*height 250px;*/
      }
    }

    .xiangqing {
      font-weight 500;
      font-size 16px;
      color #333333;
      width 90%;
      margin 10px auto;
    }

    .xi {
      width 90%;
      margin 10px auto;
      line-height 1.5
    }

    .xiangqingtu {
      width 90%;
      margin 0px auto;

      img {
        width 100%;
        display block
      }
    }

    .shiping {
      position relative;
      margin-top 10px;

      >>> .van-collapse-item__content {
        padding 0px;
      }
      width 90%;
      margin 10px auto;
      display flex;

      .xiabiao {
        margin-right 10px;
      }

      .kecheng {

      }

      .bofang {
        position absolute;
        right 0px;

        img {
          width 20px;
          height 20px;
        }
      }
    }

    .pinglun {
      width 90%;
      margin 10px auto;
      display flex

      .touxiang {
        /*margin-top 10px;*/

        img {
          width 30px;
          height 30px;
          border-radius 30px;
        }
      }

      .neirong {
        margin-left 10px;

        .name {
          color #333333;
          font-size 14px;
          line-height 30px
          font-weight 500
        }

        .ping {
          margin-top 0px;
          color #444;
        }

        .shijian {
          /*margin-top 5px;*/
          color #ccc;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ziyuanku/bofang.vue